export { SearchResultNone } from './none';
